export default __webpack_public_path__ + "images/anexar-foto-usuario-ico.svg";